//#region Imports
import React, { useEffect, useLayoutEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import { Backdrop, Box, Button, CircularProgress, Grid, MenuItem, Select, Typography, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import warning from '../../../images/warning.png';
import { tableStyleOverDue } from '../../../style/common';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import crossIcon from "../../../images/remove.png";
import pdfIcon from "../../../images/pdfIcon.png";

//components
//scss
// import "./DueDateExtensionTable.scss"
import "../../../style/common.scss";
//Yup
import * as Yup from "yup";
//formik

import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
import CheckPermissions from '../../../authorization/authorization';
//Services
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import ProcessingSummaryTable from '../../../components/processingSummaryTable/processingSummaryTable';
import { tableStyle } from '../../../style/common';

import { useDispatch, useSelector } from 'react-redux';
import BasicTable from '../../../components/basicTable/basicTable';
import Error from '../../../components/error/error';
import { SearchIndividualApplication } from '../../../network/APIs/APIs';
import { addBusinessDays, calculateRemainingBusinessDays, dBillAPI, daysBetweenDatesExcludingWeekendsAndHolidays, downloadBill, getDocumentBackGroundColor, numberFormatting, subdivisionName } from '../../../services/Functions';
import tickicon from "../../../images/Accept.png";

import {
    fetchPaginatedPartPaymentNormal,
    filterDateFrom as filterDateFromNormal,
    filterDateTo as filterDateToNormal,
    filterObjectionStatus as filterObjectionStatusNormal,
    filterProgressId as filterProgressIdNormal,
    firstPage as firstPageNormal,
    lastPage as lastPageNormal,
    nextPage as nextPageNormal,
    previousPage as previousPageNormal,
    resetDateFilter as resetDateFilterNormal,
    resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
    resetProgressIdFilter as resetProgressIdFilterNormal
} from '../../../features/billingAndCollection/partPaymentNormalSlice';

import {
    fetchPaginatedPartPaymentOverdue,
    filterDateFrom as filterDateFromOverdue,
    filterDateTo as filterDateToOverdue,
    filterObjectionStatus as filterObjectionStatusOverdue,
    filterProgressId as filterProgressIdOverdue,
    firstPage as firstPageOverdue,
    lastPage as lastPageOverdue,
    nextPage as nextPageOverdue,
    previousPage as previousPageOverdue,
    resetDateFilter as resetDateFilterOverdue,
    resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
    resetProgressIdFilter as resetProgressIdFilterOverdue
} from '../../../features/billingAndCollection/partPaymentOverdueSlice';
import Base64Image from '../../../components/Base64Image/Base64Image';
import OpenBase64ImageInPopup from '../../../services/OpenBase64ImageInPopup';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
//#endregion

const AmendBill2636Table = forwardRef((props, ref) => {

    //#region initial values
    const initialValues = {
        iv_approved_no_of_days: null,
        iv_approved_due_date: null,
        claimedPaymentAmount: "",
    }
    //#endregion

    //#region get item local storage
    const { token, code: officeCode, hierarchy: officeHierarchy, userId, permissions } = useSelector((state) => state.auth);
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const navigate = useNavigate();
    //#endregion

    //#region states

    const [error, setError] = useState()
    const [ddeApplicationsNormal, setDdeApplicationsNormal] = useState([]);
    const [ddeApplicationsNormalToDataGrid, setDdeApplicationsNormalToDataGrid] = useState([]);
    const [dayName, setDayName] = useState('-');
    const [ddeApplicationsOverdue, setDdeApplicationsOverdue] = useState([]);
    const [ddeApplicationsOverdueToDataGrid, setDdeApplicationsOverdueToDataGrid] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [applicationId, setapllicationid] = React.useState('')
    const [eFileData, setEFileData] = useState([]);
    const [billAdjustmentDocuments, setBillAdjustmentDocuments] = useState([]);
    const [documentsLoading, setDocumentsLoading] = useState(false);
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [applicationSubittedPopUp, setApplicationSubmittedPopUp] = useState(false);
    const [availableDays, setAvailableDays] = useState([]);
    const [approvedPopup, setApprovedPopup] = useState(false)
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [actionTakenPopup, setActionTakenPopup] = useState(false);

    const [approvedPayment, setApprovedPayment] = useState("");
    const [approvedPaymentError, setApprovedPaymentError] = useState("");

    const [flag_applicantCNICFront, setFlag_applicantCNICFront] = useState(null);
    const [flag_applicantCNICBack, setFlag_applicantCNICBack] = useState(null);
    const [flag_paidBillImageFlag, setFlag_paidBillImageFlag] = useState(null);
    const [
        applicantCNICBackObjectionRemarks,
        setApplicantCNICBackObjectionRemarks,
    ] = useState("");
    const [documnets, setDocuments] = useState({})
    const [apiPopup, setApiPopup] = useState({ open: false, type: '', message: '' });
    const tableColumnsProcessingSummary = [
        {
            header: 'Step',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },
        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },
    ]

    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
    ])
    const dispatch = useDispatch();
    let DDStatusBarArray = [
        {
            title1: 'APPLICATION',
            title2: 'SUBMITTED',
        },
        {
            title1: 'ACTION',
            title2: 'TAKEN',
        },

    ]

    const [foundInDDE, setFoundInDDE] = useState();
    const { state } = useLocation();
    const { foundId } = state ? state : '';
    const [isReleventToUser, setIsRelevantToUser] = useState(false)
    const [
        applicantCNICFrontObjectionRemarks,
        setApplicantCNICFrontObjectionRemarks,
    ] = useState("");
    const [
        paidBillImageObjectionRemarks,
        setPaidBillImageObjectionRemarks,
    ] = useState("");
    const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] =
        useState(false);
    const [paidBillImagePopUp, setPaidBillImagePopUp] = useState(false);
    const [owenershipDocumentVerifyPopUp, setOwenershipDocumentVerifyPopUp] =
        useState(false);
    //#endregion

    //#endregion

    const { currentPage: currentPageNormal, data: dataNormal, pageSize: pageSizeNormal, totalPages: totalPagesNormal, totalRecords: totalRecordsNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, error: errorNormal, isLoading: isLoad } = useSelector((state) => state.partPaymentNormalPaginated);
    const { currentPage: currentPageOverdue, data: dataOverdue, pageSize: pageSizeOverdue, totalPages: totalPagesOverdue, totalRecords: totalRecordsOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, error: errorOverdue, isLoading: isLoadd } = useSelector((state) => state.partPaymentOverduePaginated);

    const handleNextPage = () => {
        setViewBackdrop(true)
        dispatch(nextPageNormal());
    };

    const handleDateFromFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromNormal(value))
        }
    }

    const handleDateToFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToNormal(value))
        }
    }

    const handleResetDateFilter = () => {
        dispatch(resetDateFilterNormal())
    }

    const handleProgressIdFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdNormal(value))
        }
    }

    const handleResetProgressIdFilter = () => {
        dispatch(resetProgressIdFilterNormal())
    }

    const handleObjectionStatusFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusNormal(value))
        }
    }

    const handleResetObjectionStatusFilter = () => {
        dispatch(resetObjectionStatusFilterNormal())
    }

    const handlePreviousPage = () => {
        setViewBackdrop(true)
        dispatch(previousPageNormal());
    };

    const handleFirstPage = () => {
        dispatch(firstPageNormal());
    };

    const handleLastPage = () => {
        dispatch(lastPageNormal(totalPagesNormal)); // Replace '2' with actual value
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/amend-2636-bill-table") && token) {
            setViewBackdrop(true)
            dispatch(fetchPaginatedPartPaymentNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, officeCode }));
        }
    }, [currentPageNormal, pageSizeNormal, dateFromNormal, dateToNormal, applicationProgressIdNormal, objectionStatusNormal]);



    useEffect(() => {
        if (dataNormal) {
            setDdeApplicationsNormal(dataNormal)
            setViewBackdrop(false)
        }
    }, [dataNormal])

    const handleNextPageOverdue = () => {
        setViewBackdrop(true)
        dispatch(nextPageOverdue());
    };

    const handleDateFromFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromOverdue(value))
        }
    }

    const handleDateToFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToOverdue(value))
        }
    }

    const handleResetDateFilterOverdue = () => {
        dispatch(resetDateFilterOverdue())
    }

    const handleProgressIdFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdOverdue(value))
        }
    }

    const handleResetProgressIdFilterOverdue = () => {
        dispatch(resetProgressIdFilterOverdue())
    }

    const handleObjectionStatusFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusOverdue(value))
        }
    }

    const handleResetObjectionStatusFilterOverdue = () => {
        dispatch(resetObjectionStatusFilterOverdue())
    }

    const handlePreviousPageOverdue = () => {
        setViewBackdrop(true)
        dispatch(previousPageOverdue());
    };

    const handleFirstPageOverdue = () => {
        dispatch(firstPageOverdue());
    };

    const handleLastPageOverdue = () => {
        dispatch(lastPageOverdue(totalPagesOverdue)); // Replace '2' with actual value
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/amend-2636-bill-table")) {
            if (token) {
                setViewBackdrop(true)
                dispatch(fetchPaginatedPartPaymentOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, officeCode }));
            }
        }
    }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, applicationProgressIdOverdue, objectionStatusOverdue]);

    useEffect(() => {
        if ((props.showTable && currentPath == "/amend-2636-bill-table")) {
            setViewBackdrop(true)
            dispatch(fetchPaginatedPartPaymentOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, officeCode }));
        }
    }, []);

    useEffect(() => {
        if (dataOverdue) {
            setDdeApplicationsOverdue(dataOverdue)
            setViewBackdrop(false)
        }
    }, [dataOverdue])

    //#region api function
    const duedateextensionapi = async (x, values) => {
        setViewBackdrop(true)
        const formattedDate = values.split("-").reverse().join("-");
        console.log(formattedDate, values, 'formattedDate')
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        formdata.append("lastModifiedBy", userId);
        formdata.append("applicationProgressId", x);
        formdata.append("approvedExtendedDueDate", formattedDate);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    setViewBackdrop(false)
                    handleClose()
                    // window.location.reload();
                } else if (result.message.startsWith('Since the month end process')) {
                    setError(result.message)
                    setViewBackdrop(false)
                } else if (result.status === '400') {
                    setError(result.message)
                    setViewBackdrop(false)
                }
            })
            .catch(error => console.log('error', error));
    }




    const errorCloses = () => {
        setError('')
    }

    const handleClose = () => {
        setOpen(false);
        if (!props.showTable && typeof props.onCloseSearchResults === "function") {
            props.onCloseSearchResults();
        }
        setFlag_applicantCNICFront(null);
        setFlag_applicantCNICBack(null);
        setFlag_paidBillImageFlag(null);
        setDocuments({});
        setApiPopup((prev) => ({
            ...prev,
            open: false
        }));
    }

    const handleCloseRemarks = () => {
        setOpenCancelModal(false);
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                    console.warn('Invalid code format:', code);
                }
            }
        },
        minLength: 4, // EAN13
    });



    const getClassName = (x) => {
        if (x === "Pending") {
            return 'pending-button';
        }
        else if (x === "In Process") {
            return 'inprocess-button';
        }
        else if (x === "Approved") {
            return 'approved-button';
        }
        else if (x === "Objection") {
            return 'objection-button';
        }
        else if (x === "Rejected") {
            return 'rejected-button';
        }
    }

    const filterNCApp = async (applicationId) => {
        let myArray = ddeApplicationsNormal
        let totalArray = myArray.concat(ddeApplicationsOverdue)
        let itemFound = totalArray.find(item => item.applicationId === applicationId)
        console.log(itemFound, 'item found')

        if (itemFound) {
            setIsRelevantToUser(true)
        }
        else if (itemFound === undefined) {
            itemFound = await SearchIndividualApplication(token, applicationId, '17')
            console.log(itemFound, 'itemFound')
            if (itemFound) {
                setIsRelevantToUser(itemFound.isReleventToUser)
            }
        }
        return itemFound;
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const convertDatewithTime = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    }

    const apiToDataGridConversionNormal = () => {

        const tempArray = []
        if (ddeApplicationsNormal) {
            ddeApplicationsNormal.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.referenceNo,
                            "name": item.applicantName,
                            "dueDate": convertDate(item.currentBillDueDate),
                            // "extendedDueDate": item.appliedExtentionOfDueDate,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.applicationProgressId,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.referenceNo,
                            "name": item.applicantName,
                            "dueDate": convertDate(item.currentBillDueDate),
                            // "extendedDueDate": item.appliedExtentionOfDueDate,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.applicationProgressId,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setDdeApplicationsNormalToDataGrid(tempArray);
    }

    const apiToDataGridConversionOverdue = () => {

        const tempArray = []
        if (ddeApplicationsOverdue) {
            ddeApplicationsOverdue.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.referenceNo,
                            "name": item.applicantName,
                            "dueDate": convertDate(item.currentBillDueDate),
                            // "extendedDueDate": convertDate(item.appliedExtentionOfDueDate),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.referenceNo,
                            "name": item.applicantName,
                            "dueDate": convertDate(item.currentBillDueDate),
                            // "extendedDueDate": convertDate(item.appliedExtentionOfDueDate),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setDdeApplicationsOverdueToDataGrid(tempArray);
    }

    const statusFunc = (x, objection) => {
        if (x === 0) {
            return 'In Process'
        }
        else if (x === 1) {
            return 'Approved'
        }
        else if (x === -1) {
            return 'Rejected'
        }
    }

    const progFunc = (x) => {
        if (x === 0) {
            return 'Documents Uploading'
        }
        else if (x === 1) {
            return 'Documents Verification'
        }
        // else if (x === 2) {
        //     return 'Arrears Verification'
        // }
        // else if (x === 3) {
        //     return 'Field Verification'
        // }
        // else if (x === 4) {
        //     return 'Demand Note Issued'
        // }
        // else if (x === 5) {
        //     return 'DN Payment Verification'
        // }
        // else if (x === 6) {
        //     return 'Meter Installation'
        // }
        // else if (x === 7) {
        //     return 'Ready for Billing'
        // }
    }
    const formatToDDMMYYYY = (dateString) => {
        if (!dateString) return "-";

        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };
    const handleRowClick = async (applicationId, event) => {
        setViewBackdrop(true);
        const item = await filterNCApp(applicationId);
        if (item) {
            setDialogRowData(item);
            setFlag_applicantCNICFront(item.applicantCNICFrontFlag);
            setFlag_applicantCNICBack(item.applicantCNICBackFlag);
            setFlag_paidBillImageFlag(item.paidBillImageFlag);
            // setFlag_electricityBillDocument(item.electricityBillFlag);

            let dataforTable = [];

            if (item.applicationProgressId === 0) {
                dataforTable.push({
                    date: convertDate(item.creationDate),
                    processedBy: item.createdBy,
                    stepName: "Application Submitted",
                    time: convertDatewithTime(item.creationDate).slice(11, 17),
                    remarks: 'Application Submitted.'
                });
            }
            else if (item.applicationProgressId === 1 || (item.applicationProgressId === 2  && item.objectionStatus !== 1)) {
                // Only show Application Submitted for In Process
                dataforTable.push({
                    date: convertDate(item.creationDate),
                    processedBy: item.createdBy,
                    stepName: "Application Submitted",
                    time: convertDatewithTime(item.creationDate).slice(11, 17),
                    remarks: 'Application Submitted.'
                });

            }
            else if (item.applicationProgressId === 3 || (item.applicationProgressId === 2 && item.objectionStatus === 1)) {
                // Show Action Taken and Application Submitted for Completed
                dataforTable.push({
                    stepName: "Action Taken",
                    processedBy: item.lastModifiedBy || 'N/A',
                    date: item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'N/A',
                    remarks: (item.applicationProgressId === 2 && item.objectionStatus === 1) ? 'Reject' : item.remarks || '-',
                });

                dataforTable.push({
                    date: convertDate(item.creationDate),
                    processedBy: item.createdBy,
                    stepName: "Application Submitted",
                    time: convertDatewithTime(item.creationDate).slice(11, 17),
                    remarks: 'Application Submitted.'
                });

            }

            setTableDataProcessingSummary(dataforTable);

            setapllicationid(item.applicationId)
            await getBillAdjustmentDocuments(item.applicationId);
            setViewBackdrop(false);
            setOpen(true);
        } else {
            setViewBackdrop(false);
        }
    };

    const openDetailsPopUp = async (stepName) => {
        let id = dialogRowData.applicationId

        if (stepName === "APPLICATION SUBMITTED" || stepName === "Application Submitted") {
            setApplicationSubmittedPopUp(true)
        }
        else if (stepName === "ACTION TAKEN" || stepName === "Action Taken") {
            setActionTakenPopup(true)
        }
    }

    const stepName = (x) => {
        if (x === 0) {
            return 'Application Submission'
        }
        else if (x === 1 || x === -1) {
            return 'Action Taken'
        }
    };

    //#endregion

    //#endregion

    //#region useEffects

    useEffect(() => {
        if (ddeApplicationsNormal) {
            apiToDataGridConversionNormal()
        }
    }, [ddeApplicationsNormal]);

    useEffect(() => {
        if (ddeApplicationsOverdue) {
            apiToDataGridConversionOverdue()
        }
    }, [ddeApplicationsOverdue]);

    useEffect(() => {
        if (foundId && foundId !== '') {
            setFoundInDDE(foundId)
        }
    }, [foundId])

    useLayoutEffect(() => {
        if (foundInDDE) {
            handleRowClick(foundInDDE)
        }
    }, [foundInDDE])

    const getDayName = (dateString) => {
        if (!dateString) return "-";

        let date;

        if (dateString.includes("-") && dateString.split("-")[0].length === 4) {
            const [year, month, day] = dateString.split("-");
            date = new Date(Number(year), Number(month) - 1, Number(day));
        } else if (dateString.includes("-")) {
            const [day, monthStr, year] = dateString.split("-");
            const month = new Date(Date.parse(monthStr + " 1, 2020")).getMonth();
            date = new Date(Number(year), month, Number(day));
        } else {
            return "-";
        }

        if (isNaN(date)) return "-";
        return date.toLocaleString("en-US", { weekday: "long" });
    };
    const formatDateToShortMonth = (dateString) => {
        if (!dateString) return "-";

        const [day, month, year] = dateString.split("-");
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const monthIndex = parseInt(month, 10) - 1;
        if (monthIndex < 0 || monthIndex > 11) return "-";

        return `${day}-${months[monthIndex]}-${year}`;
    };


    //#endregion

    const tblColumns = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "dueDate", type: 'dateTime', headerName: 'Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "applicationProgressId",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (row) => {
                let btnText = row.applicationProgressId === 1 ? 'In Process' : (row.applicationProgressId === 2 && row.objectionStatus != 1) ? 'In Process' : (row.applicationProgressId === 2 && row.objectionStatus == 1) ? 'Rejected' : (row.applicationProgressId === 3) ? 'Approved' : (row.applicationProgressId === 4) ? 'Approved' : '-';
                // let textColor = row.applicationProgressId === 1 ? '#0d6efd' : row.applicationProgressId === 2 ? '#198754' : '#6c757d';
                let textColor = row.applicationProgressId === 1 ? '#0d6efd' : (row.applicationProgressId === 2 && row.objectionStatus != 1) ? '#0d6efd' : (row.applicationProgressId === 2 && row.objectionStatus == 1) ? '#E11B3C' : (row.applicationProgressId === 3) ? '#2e7d32' : (row.applicationProgressId === 4) ? '#b7e1c0' : '-';

                return (
                    <div style={{
                        color: textColor,
                        fontWeight: 600
                    }}>
                        {btnText}
                    </div>
                )
            }
        },
    ]

    const tblColumnsOverDue = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "name", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "dueDate", type: 'dateTime', headerName: 'Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        {
            field: "applicationProgressId",
            headerStyle: tableStyleOverDue.headerStyle,
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: tableStyleOverDue.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (row) => {
                let btnText = row.applicationProgressId === 1 ? 'In Process' : row.applicationProgressId === 2 ? 'Approved' : '-';
                let textColor = row.applicationProgressId === 1 ? '#0d6efd' : row.applicationProgressId === 2 ? '#198754' : '#6c757d';
                return (
                    <div style={{
                        color: textColor,
                        fontWeight: 600
                    }}>
                        {btnText}
                    </div>
                )
            }
        },
    ]

    useImperativeHandle(ref, () => ({
        handleRowClick
    }));

    const location = useLocation()
    const currentPath = location.pathname;

    const ranges = [
        { max: 25000, perm: '1 - 25,000' },
        { max: 50000, perm: '25,001 - 50,000' },
        { max: 100000, perm: '50,001 - 100,000' },
        { max: 200000, perm: '100,001 - 200,000' },
        { max: 300000, perm: '200,001 - 300,000' },
        { max: 500000, perm: '300,001 - 500,000' },
        { max: 1000000, perm: '500,001 - 1,000,000' },
        { max: 20000000, perm: '1,000,001 - 20,000,000' },
        { max: Infinity, perm: '20,000,001 - MAX' },
    ];

    const canApprove = (billAmount) => {
        for (let i = 0; i < ranges.length; i++) {
            const { max, perm } = ranges[i];

            const hasPermission = CheckPermissions(
                permissions,
                'General Services', 'Part Payment', 'Workflow Permissions',
                perm
            );

            if (hasPermission && billAmount <= max) {
                return true;
            }
        }
        return false;
    };

    const formatMonthYear = (dateString) => {
        if (!dateString) return '-';
        const cleanDateString = dateString.split('T')[0];
        const date = new Date(cleanDateString);
        if (isNaN(date)) return '-';
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${month}-${year}`;
    };

    const isExtensionDateExpired = (dateString) => {
        if (!dateString) return false;

        const appliedDate = new Date(dateString);
        const today = new Date();


        appliedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return appliedDate < today;
    };



    const remarksFormik = useFormik({
        initialValues: {
            iv_remarks: "",
            // Add iv_approved_due_date if it’s part of the form
            // iv_approved_due_date: "",
        },
        validationSchema: Yup.object({
            iv_remarks: Yup.string()
                .min(10, "Remarks should be at least 10 characters.")
                .max(100, "Remarks should be less than 100 characters.")
                .required("Enter remarks."),
            // Add validation for iv_approved_due_date if needed
            // iv_approved_due_date: Yup.string().required("Date is required."),
        }),
        onSubmit: async (values) => {
            const x = -1;
            const formattedDate = dialogRowData.appliedExtentionOfDueDate
            console.log("x:", x, "userId:", userId, "applicationId:", applicationId, "Date", formattedDate, "values", values);
            setViewBackdrop(true);
            try {
                const formdata = new FormData();
                //   formdata.append("remarks", values.iv_remarks); 
                formdata.append("applicationId", applicationId);
                formdata.append("lastModifiedBy", userId);
                formdata.append("applicationProgressId", x);
                formdata.append("approvedExtendedDueDate", formattedDate);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                const requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };
                await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === '200') {
                            setOpenCancelModal(false);
                            handleClose();
                        } else if (result.message?.startsWith('Since the month end process')) {
                            setError(result.message);
                        } else {
                            setError('Failed to submit the application.');
                        }
                    })
                    .catch(error => console.log('error', error));
            } catch (e) {
                console.error("Submission error:", e);
            }
            setViewBackdrop(false);

        },
    });

    const hideCopyOfApplicantCNICVerifyAlert = (x) => {
        setCopyOfApplicantCNICVerifyPopUp(x);
    };

    const hidePropertyDocVerifyAlert = (x) => {
        setPaidBillImagePopUp(x);
    };

    const callingUpdateDocumentStatusAPI = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        let progId = null;
        let objStat = null;
        let remrks = "";
        let remarksDetail = "";

        if (flag_applicantCNICFront === -1 || flag_applicantCNICBack === -1) {
            progId = 1;
            objStat = 1;
            remrks = "Documents Rejected.";
            remarksDetail = "Documents Objection in : ".concat(
                flag_applicantCNICFront === -1 ? "CNIC Front, " : "",
                flag_applicantCNICBack === -1 ? "CNIC Back" : ""
            );
        } else if (flag_applicantCNICFront === 1 && flag_applicantCNICBack === 1) {
            progId = 2;
            objStat = 0;
            remrks = "Documents Verified.";
            remarksDetail = "CNIC Front Verified. CNIC Back Verified.";
        }

        console.log("progId:", progId, "objStat:", objStat, "remrks:", remrks, "remarksDetail:", remarksDetail);

        const raw = JSON.stringify({
            applicationId: dialogRowData.applicationId,
            applicationProgressId: progId,
            objectionStatus: objStat,
            remarks: remrks,
            remarksDetail: remarksDetail,
            applicantCNICFrontFlag: flag_applicantCNICFront,
            applicantCNICBackFlag: flag_applicantCNICBack,
            applicantCNICFrontRemarks: applicantCNICFrontObjectionRemarks,
            applicantCNICBackRemarks: applicantCNICBackObjectionRemarks,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        await fetch(cfpBaseUrl + "billAdjustment/partPayment/verifyDocuments", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === "200") {
                    // For both verify and reject, just close and reload - no popup
                    // Popup will show on Claimed Part Payment Approve
                    handleClose();
                    window.location.reload();
                } else {
                    setError(result.message || "Failed to update document status");
                }
                setViewBackdrop(false);
            })
            .catch((error) => {
                console.error(error);
                setError("Failed to update document status");
                setViewBackdrop(false);
            });
    };

    const updateDocumentStatus = () => {

        console.log(flag_applicantCNICBack, flag_applicantCNICFront, flag_paidBillImageFlag, "flagsvalues");
        // For Part Payment, only check CNIC Front and Back (no paid bill image)
        if (flag_applicantCNICFront !== null && flag_applicantCNICBack !== null) {
            callingUpdateDocumentStatusAPI();
        } else {
            setError("Check all the attached documents before submitting!");
        }
    };



    let CONStatusBarArray = [
        {
            title1: "DOCUMENT",
            title2: "SUBMISSION",
        },
        {
            title1: "DOCUMENT",
            title2: "VERIFICATION",
        },
        {
            title1: "PROCESS",
            title2: "PART PAYMENT",
        },
        {
            title1: "COMPLETED",
            title2: "",
        },
    ];


    const getBillAdjustmentDocuments = async (appId) => {
        setDocumentsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "applicationId": appId
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        await fetch(cfpBaseUrl + "billAdjustment/partPayment/getDocuments", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                console.log("Documents API Response:", result);
                if (result.status === "200" && result.data?.length > 0) {
                    console.log("Documents Data:", result.data[0]);
                    setDocuments(result.data[0]);
                } else {
                    console.log("Documents API failed with status:", result.status);
                    setDocuments({});
                }
                setDocumentsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setDocuments({});
                setDocumentsLoading(false);
            });
    }



    const updateDocFlag = (documentName, value, remarks) => {
        console.log(value, "valuevalue");
        switch (documentName) {
            case "copyOfApplicantCNIC":
                setFlag_applicantCNICFront(value);
                setFlag_applicantCNICBack(value);
                setApplicantCNICFrontObjectionRemarks(remarks);
                setApplicantCNICBackObjectionRemarks(remarks);
                setCopyOfApplicantCNICVerifyPopUp(false);
                break;
            case "paidBillImage":
                setFlag_paidBillImageFlag(value);
                setPaidBillImageObjectionRemarks(remarks);
                setPaidBillImagePopUp(false);
                break;

            default:
                break;
        }
    };



    const partPaymentClaim = (value) => {
        // Validation for Approved Part Payment field
        if (!approvedPayment || approvedPayment === '' || Number(approvedPayment) <= 0) {
            setApprovedPaymentError('Please enter a valid amount (must be greater than zero)');
            return;
        }
        setApprovedPaymentError(''); // Clear error if valid

        if (value === 'Approve') {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "applicationId": dialogRowData.applicationId,
                "applicationProgressId": 3,
                "objectionStatus": 0,
                "remarks": "Approved",
                "remarksDetail": "Approved for IBS",
                "approvedPartPayment": approvedPayment
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(cfpBaseUrl + "/billAdjustment/partPayment/process", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setViewBackdrop(false);
                    // Show Bill Amended Successfully popup on Approve
                    setApiPopup({
                        open: true,
                        type: 'success',
                        message: result.message || 'Part Payment adjusted successfully.'
                    });
                })
                .catch((error) => {
                    console.error(error);
                    setViewBackdrop(false);
                });
        } else {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "applicationId": dialogRowData.applicationId,
                "applicationProgressId": 2,
                "objectionStatus": 1,
                "remarks": "Approved",
                "remarksDetail": "Approved for IBS",
                "approvedPartPayment": approvedPayment
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(cfpBaseUrl + "/billAdjustment/partPayment/process", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setViewBackdrop(false);
                    window.location.reload();
                })
                .catch((error) => console.error(error));
        }

    }

    useEffect(() => {
        if (dialogRowData?.partPaymentAmount) {
            setApprovedPayment(dialogRowData.partPaymentAmount);
        }
    }, [dialogRowData])
    return (
        <>
            {
                (props.showTable && currentPath == "/amend-2636-bill-table") &&
                <Box className='form-box'>
                    <div style={{ display: 'flex', flexDirection: "row" }}>
                        <Box className='application-table' style={{ marginRight: '10px' }}>
                            <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Part Payment  ( {numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )</h3>
                            <div className='div-datagrid' >
                                <BasicTable
                                    columns={tblColumns}
                                    data={ddeApplicationsNormalToDataGrid}
                                    handleRowClick={(params) => handleRowClick(params.applicationId)}
                                    sx={tableStyle}
                                    rowHeight={37}
                                    pageSize={20}
                                    firstPage={handleFirstPage}
                                    lastPage={handleLastPage}
                                    totalPages={totalPagesNormal}
                                    totalRecords={totalRecordsNormal}
                                    currentPage={currentPageNormal}
                                    handleFilterDateFrom={handleDateFromFilter}
                                    handleFilterDateTo={handleDateToFilter}
                                    resetDateFilter={handleResetDateFilter}
                                    handleFilterProgressId={handleProgressIdFilter}
                                    handleFilterObjectionStatus={handleObjectionStatusFilter}
                                    resetProgressIdFilter={handleResetProgressIdFilter}
                                    resetObjectionStatusFilter={handleResetObjectionStatusFilter}
                                    nextPage={handleNextPage}
                                    previousPage={handlePreviousPage}
                                    isLoading={isLoad}
                                    rowsPerPageOptions={[18, 30, 60]}
                                    rowsPageOption={false}
                                    getRowStyle={(params) => {
                                        return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                                    }}
                                />
                            </div>
                        </Box>
                        <Box className='application-table' >
                            <div style={{ display: 'flex', alignItems: 'end' }}>
                                <h3 style={{ color: '#9d192f', marginBottom: '10px' }}><img src={warning} alt='icon' style={{ width: '1vw', marginRight: '5px' }} />Over Due Applications  ( {numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"} )</h3>
                            </div>
                            <div className='div-datagrid' >
                                <BasicTable
                                    columns={tblColumnsOverDue}
                                    data={ddeApplicationsOverdueToDataGrid}
                                    handleRowClick={(params) => handleRowClick(params.applicationId)}
                                    sx={tableStyleOverDue}
                                    rowHeight={37.5}
                                    pageSize={20}
                                    firstPage={handleFirstPageOverdue}
                                    nextPage={handleNextPageOverdue}
                                    previousPage={handlePreviousPageOverdue}
                                    lastPage={handleLastPageOverdue}
                                    handleFilterDateFrom={handleDateFromFilterOverdue}
                                    handleFilterDateTo={handleDateToFilterOverdue}
                                    resetDateFilter={handleResetDateFilterOverdue}
                                    resetProgressIdFilter={handleResetProgressIdFilterOverdue}
                                    resetObjectionStatusFilter={handleResetObjectionStatusFilterOverdue}
                                    handleFilterProgressId={handleProgressIdFilterOverdue}
                                    handleFilterObjectionStatus={handleObjectionStatusFilterOverdue}
                                    totalPages={totalPagesOverdue}
                                    totalRecords={totalRecordsOverdue}
                                    currentPage={currentPageOverdue}
                                    rowsPerPageOptions={[18, 30, 60]}
                                    isLoading={isLoadd}
                                    rowsPageOption={false}
                                    getRowStyle={(params) => {
                                        return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyleOverDue.evenRow : tableStyleOverDue.oddRow
                                    }}
                                />
                            </div>
                        </Box>
                    </div>
                </Box>
            }

            {/* Main Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={"false"}
                className="main-dialog"
            >
                <DialogTitle className="dialog-title">
                    <Grid container spacing={1} className="headercontainer">
                        <Grid item lg={0.5}></Grid>
                        <Grid item lg={11} className="applicationTitleGrid">
                            <Typography className="applicationTitleText">
                                Part Payment - {(dialogRowData.applicationProgressId == 1) ? "Document Verification" : (dialogRowData.applicationProgressId == 2) ? "Process Part Payment" : (dialogRowData.applicationProgressId == 3) ? "Completed" : "Application Submission"}
                            </Typography>
                        </Grid>
                        <Grid item lg={0.25} sx={{ marginTop: "0.5%" }}>
                            {/* <PrintIcon
                                onClick={() => downloadApplicationPDF(dialogRowData)}
                                sx={{ cursor: "pointer", color: "white" }}
                            /> */}
                        </Grid>
                        <Grid item lg={0.25} className="closeIcon">
                            <CloseIcon
                                id="clearPopup"
                                onClick={handleClose}
                                sx={{ color: "white" }}
                            />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="dialog-content">
                        <Grid container spacing={1} className="headercontainer">
                            <Grid item lg={12} className="status-bar">
                                <StepProgressBar
                                    array={CONStatusBarArray}
                                    applicationProgressId={dialogRowData.applicationProgressId}
                                    pageName="Change of Name"
                                />
                            </Grid>
                            <Grid item lg={12} className="application-details">
                                <Grid
                                    container
                                    spacing={2}   // ✅ spacing fix
                                    className="first-row"
                                >
                                    <Grid item lg={1.5} className="first-row-item">
                                        <p className="prop-title">Application Id.</p>
                                        <p className="prop-detail">
                                            {dialogRowData.applicationId}
                                        </p>
                                    </Grid>

                                    <Grid item lg={1.5} className="first-row-item">
                                        <p className="prop-title">Reference No.</p>
                                        <p className="prop-detail">
                                            {dialogRowData.referenceNo || "-"}
                                        </p>
                                    </Grid>

                                    <Grid item lg={3} className="first-row-item">
                                        <p className="prop-title">Address</p>
                                        <p className="prop-detail">
                                            {dialogRowData.applicantAddress || "-"}
                                        </p>
                                    </Grid>

                                    <Grid item lg={1} className="first-row-item">
                                        <p className="prop-title">Subdivision</p>
                                        <p className="prop-detail">
                                            {subdivisionName(
                                                dialogRowData.subDivisionCode,
                                                subDivisions
                                            )}
                                        </p>
                                    </Grid>

                                    <Grid item lg={2} className="first-row-item">
                                        <p className="prop-title">Name</p>
                                        <p className="prop-detail">
                                            {dialogRowData.applicantName || "-"}
                                        </p>
                                    </Grid>

                                    <Grid item lg={1.5} className="first-row-item">
                                        <p className="prop-title">CNIC</p>
                                        <p className="prop-detail">
                                            {dialogRowData.applicantCNIC || "-"}
                                        </p>
                                    </Grid>

                                    <Grid item lg={1.5} className="first-row-item">
                                        <p className="prop-title">Current Bill Amount</p>
                                        <p className="prop-detail">
                                            {dialogRowData.currentBillAmount
                                                ? Number(dialogRowData.currentBillAmount).toLocaleString()
                                                : "-"}
                                        </p>
                                    </Grid>



                                    <Grid item lg={2} className="first-row-item">
                                        <p className="prop-title">Current Bill Month</p>
                                        <p className="prop-detail">
                                            {convertDate(dialogRowData.currentBillMonth) || "-"}
                                        </p>
                                    </Grid>

                                    <Grid item lg={2} className="first-row-item">
                                        <p className="prop-title">Claiment Payment</p>
                                        <p className="prop-detail">
                                            {dialogRowData.partPaymentAmount
                                                ? Number(dialogRowData.partPaymentAmount).toLocaleString()
                                                : "-"}
                                        </p>
                                    </Grid>
                                    <Grid item lg={2} className="first-row-item">
                                        <p className="prop-title">Approved Payment</p>
                                        <p className="prop-detail">
                                            {dialogRowData.approvedPartPayment
                                                ? Number(dialogRowData.approvedPartPayment).toLocaleString()
                                                : "-"}
                                        </p>
                                    </Grid>


                                </Grid>
                            </Grid>
                            <Grid item className='processing-summary'>
                                <p className='title'>Activity Log</p>
                                <ProcessingSummaryTable data={tableDataProcessingSummary} columns={tableColumnsProcessingSummary} openDetailsPopUp={openDetailsPopUp} />
                            </Grid>
                            <Grid item className="action-form">
                                <div className="fields">
                                    {dialogRowData.applicationProgressId === 0 ? (
                                        <>
                                            <h3 className="step-title">Documents Pending</h3>
                                            <div className="description-box">

                                            </div>
                                        </>
                                    ) : dialogRowData.applicationProgressId === 1 &&
                                        (dialogRowData.objectionStatus === 0 ||
                                            dialogRowData.objectionStatus === 2) ? (
                                        <>
                                            {CheckPermissions(permissions, 'General Services', 'Part Payment', 'Workflow Permissions', 'Document Verification') ? (
                                                <>
                                                    <h3 className="step-title">Document Verification</h3>
                                                    <Grid
                                                        className="document-verification-container"
                                                        container
                                                        spacing={1}
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-start",
                                                            marginTop: "1%",
                                                            padding: "2%",
                                                        }}
                                                    >
                                                        {(documnets?.applicantCNICFront ||
                                                            documnets.applicantCNICBack) && (
                                                                <Grid item lg={2}>
                                                                    <Grid
                                                                        container
                                                                        sx={{
                                                                            backgroundColor:
                                                                                flag_applicantCNICFront !== null
                                                                                    ? getDocumentBackGroundColor(
                                                                                        flag_applicantCNICFront
                                                                                    )
                                                                                    : getDocumentBackGroundColor(
                                                                                        documnets?.applicantCNICFrontFlag
                                                                                    ),
                                                                            borderRadius: "10px",
                                                                            minHeight: "125px",
                                                                            height: "auto",
                                                                        }}
                                                                    >
                                                                        <Grid
                                                                            item
                                                                            lg={12}
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                paddingBottom: "5px",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                onClick={() => {
                                                                                    if (!copyOfApplicantCNICVerifyPopUp) {
                                                                                        setCopyOfApplicantCNICVerifyPopUp(true);
                                                                                    }
                                                                                }}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    flexDirection: "column",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                {documnets.applicantCNICFront.slice(
                                                                                    0,
                                                                                    6
                                                                                ) === "data:i" ? (
                                                                                    flag_applicantCNICFront === 1 ? (
                                                                                        <>
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICFront
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICBack
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <img
                                                                                                src={tickicon}
                                                                                                width="25px"
                                                                                                height="25px"
                                                                                                alt="Tick Icon"
                                                                                                style={{
                                                                                                    position: "relative",
                                                                                                    zIndex: "2",
                                                                                                    marginRight: "-120px",
                                                                                                    marginTop: "-30px",
                                                                                                }}
                                                                                            />
                                                                                        </>
                                                                                    ) : flag_applicantCNICFront === -1 ? (
                                                                                        <>
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICFront
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICBack
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <img
                                                                                                src={crossIcon}
                                                                                                width="25px"
                                                                                                height="25px"
                                                                                                alt="Cross Icon"
                                                                                                style={{
                                                                                                    position: "relative",
                                                                                                    zIndex: "2",
                                                                                                    marginRight: "-120px",
                                                                                                    marginTop: "-30px",
                                                                                                }}
                                                                                            />
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICFront
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICBack
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                        </>
                                                                                    )
                                                                                ) : (
                                                                                    <Base64Image data={pdfIcon} width="40" />
                                                                                )}
                                                                                {copyOfApplicantCNICVerifyPopUp && (
                                                                                    <OpenBase64ImageInPopup
                                                                                        docVerifyPopUp={
                                                                                            copyOfApplicantCNICVerifyPopUp
                                                                                        }
                                                                                        hideDocVerifyPopup={
                                                                                            hideCopyOfApplicantCNICVerifyAlert
                                                                                        }
                                                                                        documentName="Applicant CNIC"
                                                                                        documentImage={
                                                                                            documnets.applicantCNICFront
                                                                                        }
                                                                                        backDocumentImage={
                                                                                            documnets.applicantCNICBack
                                                                                        }
                                                                                        width={"100%"}
                                                                                        document={
                                                                                            documnets.applicantCNICFront
                                                                                        }
                                                                                        documentFlag={
                                                                                            documnets.applicantCNICFrontFlag
                                                                                        }
                                                                                        applicationProgressId={
                                                                                            dialogRowData.applicationProgressId
                                                                                        }
                                                                                        objectionStatus={
                                                                                            dialogRowData.objectionStatus
                                                                                        }
                                                                                        updateDocFlag={updateDocFlag}
                                                                                        documentRemarks={
                                                                                            applicantCNICBackObjectionRemarks
                                                                                        }
                                                                                        titleToUpdateFlag="copyOfApplicantCNIC"
                                                                                        flag_document={flag_applicantCNICFront}
                                                                                        flag_documentBack={
                                                                                            flag_applicantCNICBack
                                                                                        }
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item lg={12} className="tittlegrid">
                                                                            <p className="docTitle">Applicant's CNIC.</p>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            )}

                                                        {documnets?.paidBillImage && (
                                                            <Grid item lg={2}>
                                                                <Grid
                                                                    container
                                                                    sx={{
                                                                        backgroundColor:
                                                                            flag_paidBillImageFlag !== null
                                                                                ? getDocumentBackGroundColor(
                                                                                    flag_paidBillImageFlag
                                                                                )
                                                                                : getDocumentBackGroundColor(
                                                                                    documnets?.paidBillImageFlag
                                                                                ),
                                                                        borderRadius: "10px",
                                                                        minHeight: "125px",
                                                                        height: "auto",
                                                                    }}
                                                                >
                                                                    <Grid
                                                                        item
                                                                        lg={12}
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            paddingBottom: "5px",
                                                                        }}
                                                                    >
                                                                        <div
                                                                            onClick={() => {
                                                                                if (!paidBillImagePopUp) {
                                                                                    setPaidBillImagePopUp(true);
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                                flexDirection: "column",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            {documnets.paidBillImage?.slice(0, 6) === "data:i" ? (
                                                                                (flag_paidBillImageFlag === 1 || documnets.paidBillImageFlag === 1) ? (
                                                                                    <>
                                                                                        <Base64Image
                                                                                            data={
                                                                                                documnets.paidBillImage
                                                                                            }
                                                                                            width="80"
                                                                                            height="100"
                                                                                        />
                                                                                        <img
                                                                                            src={tickicon}
                                                                                            width="25px"
                                                                                            height="25px"
                                                                                            alt="Tick Icon"
                                                                                            style={{
                                                                                                position: "relative",
                                                                                                zIndex: "2",
                                                                                                marginRight: "-100px",
                                                                                                marginTop: "-40px",
                                                                                            }}
                                                                                        />
                                                                                    </>
                                                                                ) : (flag_paidBillImageFlag === -1 || documnets.paidBillImageFlag === -1) ? (
                                                                                    <>
                                                                                        <Base64Image
                                                                                            data={documnets.paidBillImage}
                                                                                            width="80"
                                                                                            height="50"
                                                                                        />
                                                                                        <img
                                                                                            src={crossIcon}
                                                                                            width="25px"
                                                                                            height="25px"
                                                                                            alt="Cross Icon"
                                                                                            style={{
                                                                                                position: "relative",
                                                                                                zIndex: "2",
                                                                                                marginRight: "-60px",
                                                                                                marginTop: "-30px",
                                                                                            }}
                                                                                        />
                                                                                    </>
                                                                                ) : (
                                                                                    <Base64Image
                                                                                        data={documnets.paidBillImage}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                )
                                                                            ) : (
                                                                                <Base64Image data={pdfIcon} width="40" />
                                                                            )}
                                                                            {paidBillImagePopUp && (
                                                                                <OpenBase64ImageInPopup
                                                                                    docVerifyPopUp={paidBillImagePopUp}
                                                                                    hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                                                                                    documentName="Paid Bill Image"
                                                                                    documentImage={documnets.paidBillImage}
                                                                                    width={"100%"}
                                                                                    document={documnets.paidBillImage}
                                                                                    documentFlag={documnets.paidBillImageFlag}
                                                                                    applicationProgressId={dialogRowData.applicationProgressId}
                                                                                    objectionStatus={dialogRowData.objectionStatus}
                                                                                    updateDocFlag={updateDocFlag}
                                                                                    documentRemarks={paidBillImageObjectionRemarks}
                                                                                    titleToUpdateFlag="paidBillImage"
                                                                                    flag_document={flag_paidBillImageFlag}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item lg={12} className="tittlegrid">
                                                                        <p className="docTitle">Paid Bill Image</p>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        )}

                                                    </Grid>
                                                </>
                                            ) : (
                                                <>
                                                    <h3 className="step-title">Documents Verification</h3>
                                                    <div className="description-box">
                                                        <p className="group-description">
                                                            <InfoIcon className="icon" /> Document verification is in process by the Customer Service Lead.
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    ) : dialogRowData.applicationProgressId === 1 &&
                                        dialogRowData.objectionStatus === 1 ? (
                                        <>
                                            <h3 className="step-title">Documents Objection</h3>
                                            <Grid
                                                className="document-verification-container"
                                                container
                                                spacing={1}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    marginTop: "1%",
                                                    padding: "2%",
                                                }}
                                            >
                                                {(documnets?.applicantCNICFront ||
                                                    documnets?.applicantCNICBack) && (
                                                        <Grid item lg={2}>
                                                            <Grid
                                                                container
                                                                sx={{
                                                                    backgroundColor:
                                                                        flag_applicantCNICFront !== null
                                                                            ? getDocumentBackGroundColor(
                                                                                flag_applicantCNICFront
                                                                            )
                                                                            : getDocumentBackGroundColor(
                                                                                documnets?.applicantCNICFrontFlag
                                                                            ),
                                                                    borderRadius: "10px",
                                                                    minHeight: "125px",
                                                                    height: "auto",
                                                                }}
                                                            >
                                                                <Grid
                                                                    item
                                                                    lg={12}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        paddingBottom: "5px",
                                                                    }}
                                                                >
                                                                    <div
                                                                        onClick={() => {
                                                                            if (!copyOfApplicantCNICVerifyPopUp) {
                                                                                setCopyOfApplicantCNICVerifyPopUp(true);
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        {documnets?.applicantCNICFront?.slice(0, 6) === "data:i" ? (
                                                                            flag_applicantCNICFront === 1 ? (
                                                                                <>
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICFront}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICBack}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <img
                                                                                        src={tickicon}
                                                                                        width="25px"
                                                                                        height="25px"
                                                                                        alt="Tick Icon"
                                                                                        style={{
                                                                                            position: "relative",
                                                                                            zIndex: "2",
                                                                                            marginRight: "-120px",
                                                                                            marginTop: "-30px",
                                                                                        }}
                                                                                    />
                                                                                </>
                                                                            ) : (documnets?.applicantCNICFrontFlag === -1 || flag_applicantCNICFront === -1) ? (
                                                                                <>
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICFront}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICBack}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <img
                                                                                        src={crossIcon}
                                                                                        width="25px"
                                                                                        height="25px"
                                                                                        alt="Cross Icon"
                                                                                        style={{
                                                                                            position: "relative",
                                                                                            zIndex: "2",
                                                                                            marginRight: "-120px",
                                                                                            marginTop: "-30px",
                                                                                        }}
                                                                                    />
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICFront}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICBack}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                </>
                                                                            )
                                                                        ) : (
                                                                            <Base64Image data={pdfIcon} width="40" />
                                                                        )}
                                                                        {copyOfApplicantCNICVerifyPopUp && (
                                                                            <OpenBase64ImageInPopup
                                                                                docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                                                                                hideDocVerifyPopup={hideCopyOfApplicantCNICVerifyAlert}
                                                                                documentName="Applicant CNIC"
                                                                                documentImage={documnets.applicantCNICFront}
                                                                                backDocumentImage={documnets.applicantCNICBack}
                                                                                width={"100%"}
                                                                                document={documnets.applicantCNICFront}
                                                                                documentFlag={documnets.applicantCNICFrontFlag}
                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                updateDocFlag={updateDocFlag}
                                                                                documentRemarks={applicantCNICBackObjectionRemarks}
                                                                                titleToUpdateFlag="copyOfApplicantCNIC"
                                                                                flag_document={flag_applicantCNICFront}
                                                                                flag_documentBack={flag_applicantCNICBack}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </Grid>
                                                                <Grid item lg={12} className="tittlegrid">
                                                                    <p className="docTitle">Applicant's CNIC.</p>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    )}

                                                {documnets?.paidBillImage && (
                                                    <Grid item lg={2}>
                                                        <Grid
                                                            container
                                                            sx={{
                                                                backgroundColor:
                                                                    flag_paidBillImageFlag !== null
                                                                        ? getDocumentBackGroundColor(flag_paidBillImageFlag)
                                                                        : getDocumentBackGroundColor(documnets.paidBillImageFlag),
                                                                borderRadius: "10px",
                                                                minHeight: "125px",
                                                                height: "auto",
                                                            }}
                                                        >
                                                            <Grid
                                                                item
                                                                lg={12}
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    paddingBottom: "5px",
                                                                }}
                                                            >
                                                                <div
                                                                    onClick={() => {
                                                                        if (!paidBillImagePopUp) {
                                                                            setPaidBillImagePopUp(true);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    {documnets.paidBillImage?.slice(0, 6) === "data:i" ? (
                                                                        flag_paidBillImageFlag === 1 ? (
                                                                            <>
                                                                                <Base64Image
                                                                                    data={documnets.paidBillImage}
                                                                                    width="80"
                                                                                    height="50"
                                                                                />
                                                                                <img
                                                                                    src={tickicon}
                                                                                    width="25px"
                                                                                    height="25px"
                                                                                    alt="Tick Icon"
                                                                                    style={{
                                                                                        position: "relative",
                                                                                        zIndex: "2",
                                                                                        marginRight: "-60px",
                                                                                        marginTop: "-30px",
                                                                                    }}
                                                                                />
                                                                            </>
                                                                        ) : (documnets.paidBillImageFlag === -1 || flag_paidBillImageFlag === -1) ? (
                                                                            <>
                                                                                <Base64Image
                                                                                    data={documnets.paidBillImage}
                                                                                    width="80"
                                                                                    height="50"
                                                                                />
                                                                                <img
                                                                                    src={crossIcon}
                                                                                    width="25px"
                                                                                    height="25px"
                                                                                    alt="Cross Icon"
                                                                                    style={{
                                                                                        position: "relative",
                                                                                        zIndex: "2",
                                                                                        marginRight: "-60px",
                                                                                        marginTop: "-30px",
                                                                                    }}
                                                                                />
                                                                            </>
                                                                        ) : (
                                                                            <Base64Image
                                                                                data={documnets.paidBillImage}
                                                                                width="80"
                                                                                height="50"
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        <Base64Image data={pdfIcon} width="40" />
                                                                    )}
                                                                    {paidBillImagePopUp && (
                                                                        <OpenBase64ImageInPopup
                                                                            docVerifyPopUp={paidBillImagePopUp}
                                                                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                                                                            documentName="Paid Bill Image"
                                                                            documentImage={documnets.paidBillImage}
                                                                            width={"100%"}
                                                                            document={documnets.paidBillImage}
                                                                            documentFlag={documnets.paidBillImageFlag}
                                                                            applicationProgressId={dialogRowData.applicationProgressId}
                                                                            objectionStatus={dialogRowData.objectionStatus}
                                                                            updateDocFlag={updateDocFlag}
                                                                            documentRemarks={paidBillImageObjectionRemarks}
                                                                            titleToUpdateFlag="paidBillImage"
                                                                            flag_document={flag_paidBillImageFlag}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </Grid>
                                                            <Grid item lg={12} className="tittlegrid">
                                                                <p className="docTitle">Paid Bill Image</p>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </>
                                    ) : dialogRowData.applicationProgressId === 2 &&
                                        (dialogRowData.objectionStatus === 0 ||
                                            dialogRowData.objectionStatus === 2) ? (
                                        <>
                                            <h3 className="step-title">Process Part Payment</h3>

                                            <Grid
                                                container
                                                spacing={2}
                                                sx={{ padding: "20px", marginTop: "10px" }}
                                            >
                                                <Grid item lg={6}>
                                                    <Typography sx={{ marginBottom: '8px', fontWeight: '500' }}>
                                                        Approved Part Payment
                                                    </Typography>

                                                    <TextField
                                                        type="number"
                                                        value={approvedPayment}
                                                        onChange={(e) => {
                                                            setApprovedPayment(e.target.value);
                                                            if (approvedPaymentError) setApprovedPaymentError('');
                                                        }}
                                                        fullWidth
                                                        placeholder="Enter amount"
                                                        error={!!approvedPaymentError}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <span style={{ marginRight: '4px', fontWeight: 'bold' }}>
                                                                    Rs.
                                                                </span>
                                                            )
                                                        }}
                                                        sx={{
                                                            backgroundColor: '#fff',
                                                            '& .MuiInputBase-input': {
                                                                fontWeight: 'bold',
                                                                fontSize: '16px',
                                                            },
                                                        }}
                                                    />
                                                    {approvedPaymentError && (
                                                        <Typography sx={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px' }}>
                                                            {approvedPaymentError}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                            </Grid>

                                        </>
                                    ) : dialogRowData.applicationProgressId === 2 &&
                                        (dialogRowData.objectionStatus === 1) ? (
                                        <>
                                            <h3 className="step-title">Claimed Part Payment Objection</h3>

                                            {/* Rejection Message */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "8px",
                                                    marginTop: "16px",
                                                    padding: "12px 16px",
                                                    backgroundColor: "#ffebee",
                                                    border: "1px solid #ffcdd2",
                                                    borderRadius: "8px",
                                                    color: "#c62828",
                                                    fontSize: "15px",
                                                    fontWeight: 500
                                                }}
                                            >
                                                <CancelIcon sx={{ color: "#d32f2f" }} />
                                                This application is rejected by sanctioned authority
                                            </Box>

                                            <Grid
                                                container
                                                spacing={2}
                                                sx={{ padding: "20px", marginTop: "10px" }}
                                            >
                                                <Grid item lg={6}>
                                                    <Typography sx={{ marginBottom: '8px', fontWeight: '500' }}>
                                                        Claimed Part Payment
                                                    </Typography>

                                                    <TextField
                                                        type="text"
                                                        value={dialogRowData.approvedPartPayment
                                                            ? Number(dialogRowData.approvedPartPayment).toLocaleString()
                                                            : '-'}
                                                        disabled
                                                        fullWidth
                                                        InputProps={{
                                                            startAdornment: (
                                                                <span style={{ marginRight: '4px', fontWeight: 'bold' }}>
                                                                    Rs.
                                                                </span>
                                                            )
                                                        }}
                                                        sx={{
                                                            backgroundColor: '#f5f5f5',
                                                            '& .MuiInputBase-input': {
                                                                fontWeight: 'bold',
                                                                fontSize: '16px',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                        </>
                                    ) : dialogRowData.applicationProgressId === 3 &&
                                        (dialogRowData.objectionStatus === 0 ||
                                            dialogRowData.objectionStatus === 2) ? (
                                        <>
                                            <Grid
                                                container
                                                className="step-title"
                                                sx={{ marginBottom: "0.5%", padding: "0.5%" }}
                                            >
                                                <Grid item lg={1}></Grid>

                                                <Grid item lg={10} sx={{ textAlign: "center" }}>
                                                    <h4>Application Completed</h4>
                                                </Grid>
                                                <Grid item lg={1} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                                    <DescriptionIcon
                                                        sx={{ color: '#006ad1', cursor: 'pointer', backgroundColor: 'white', borderRadius: '4px', padding: '2px' }}
                                                        onClick={() => downloadBill(dialogRowData.referenceNo)}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* Success Message */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "8px",
                                                    marginTop: "8px",
                                                    padding: "10px 16px",
                                                    backgroundColor: "#e6f4ea",
                                                    border: "1px solid #b7e1c0",
                                                    borderRadius: "8px",
                                                    color: "#1b5e20",
                                                    fontSize: "15px",
                                                    fontWeight: 500
                                                }}
                                            >
                                                <CheckCircleIcon sx={{ color: "#2e7d32" }} />
                                                Completed
                                            </Box>
                                        </>

                                    ) : null}
                                </div>
                                <div className="actions">
                                    {dialogRowData.applicationProgressId === 1 &&
                                        (dialogRowData.objectionStatus === 0 ||
                                            dialogRowData.objectionStatus === 2) ? (
                                        CheckPermissions(permissions, 'General Services', 'Part Payment', 'Workflow Permissions', 'Document Verification') ?
                                            <>
                                                {(dialogRowData.applicantCNICFrontFlag !== 1 ||
                                                    dialogRowData.applicantCNICBackFlag !== 1 ||
                                                    (documnets?.paidBillImage && documnets?.paidBillImageFlag !== 1)) ? (
                                                    <>
                                                        <button
                                                            disabled={
                                                                !flag_applicantCNICFront ||
                                                                !flag_applicantCNICBack ||
                                                                (documnets?.paidBillImage && !flag_paidBillImageFlag)
                                                            }
                                                            onClick={() => updateDocumentStatus()}
                                                            className="view-button"
                                                            style={{
                                                                backgroundColor:
                                                                    (flag_applicantCNICFront === -1 ||
                                                                        flag_applicantCNICBack === -1 || flag_paidBillImageFlag === -1)
                                                                        ? "#E11B3C"
                                                                        : "#003971",
                                                            }}
                                                        >
                                                            {flag_applicantCNICFront === -1 ||
                                                                flag_applicantCNICBack === -1 || flag_paidBillImageFlag === -1
                                                                ? "Reject"
                                                                : "Verify"}
                                                        </button>
                                                    </>
                                                ) : null}
                                            </>
                                            :
                                            null
                                    ) : dialogRowData.applicationProgressId === 1 &&
                                        dialogRowData.objectionStatus === 1 ? (
                                        <>

                                            <button
                                                onClick={() => {
                                                    setOpen(false);
                                                    navigate("/part-payment-update", { state: { dialogRowData } });
                                                }}
                                                className="view-button"
                                            >
                                                Re-Upload Document
                                            </button>

                                        </>
                                    ) : (dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 0) ? (
                                        canApprove(dialogRowData.partPaymentAmount) ? (
                                            <>
                                                <button
                                                    onClick={() => partPaymentClaim('Approve')}
                                                    className="view-button"
                                                >
                                                    Approve
                                                </button>
                                                <button
                                                    style={{
                                                        backgroundColor: "#E11B3C",
                                                        marginRight: '10px'
                                                    }}
                                                    onClick={() => partPaymentClaim("Reject")}
                                                    className="view-button"
                                                >
                                                    Reject
                                                </button>
                                            </>
                                        ) : (
                                            // <p style={{ color: '#888', fontSize: '14px', margin: '10px 0' }}>
                                            //     You don't have permission to approve this amount
                                            // </p>
                                            // <div className="description-box">
                                            //     <p className="group-description">
                                            //         <InfoIcon className="icon" />
                                            //         You don't have permission to approve this amount
                                            //     </p>
                                            // </div>
                                            <div className="description-box">
                                                <p className="group-description">
                                                    <InfoIcon className="icon" />
                                                    You don't have permission to approve this amount
                                                </p>
                                            </div>
                                        )
                                    ) : null}
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            < Dialog
                open={applicationSubittedPopUp}
                onClose={() => { setApplicationSubmittedPopUp(false) }}
                fullWidth={true}
                maxWidth={'md'}
                className='subpopup-dialog1' >
                <DialogTitle className='dialog-title'>
                    <p className='title'>
                        Application Submitted
                    </p>
                    <CloseIcon id="clearPopup" className='closeIcon' onClick={() => { setApplicationSubmittedPopUp(false) }} />
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <Grid container gap={1} className='container' >
                        <Grid item lg={12} className='application-details'>
                            <Grid item lg={3} className='first-row-item' >
                                <p className='prop-title'>Application Id</p>
                                <p className=' prop-detail'>{dialogRowData.applicationId}</p>
                            </Grid>
                            <Grid item lg={3} className='first-row-item' >
                                <p className='prop-title'>Applicant Name</p>
                                <p className=' prop-detail'>{dialogRowData.applicantName}</p>
                            </Grid>
                            <Grid item lg={3} className='first-row-item' >
                                <p className='prop-title'>Current Bill Amount</p>
                                <p className=' prop-detail'>{dialogRowData.currentBillAmount}</p>
                            </Grid>
                            <Grid item lg={3} className='first-row-item' >
                                <p className='prop-title'>Sub. Through</p>
                                <p className=' prop-detail'>{dialogRowData.submittedThrough}</p>
                            </Grid>
                        </Grid>
                        <Grid item lg={12} className='application-details1' sx={{ gap: '20px' }}>
                            <Grid item lg={3} className='first-row-item' >
                                <p className='prop-title'>Applied Date</p>
                                <p className=' prop-detail'>{convertDate(dialogRowData.creationDate)}</p>
                            </Grid>
                            <Grid item lg={3} className='first-row-item' >
                                <p className='prop-title'>Subdivision</p>
                                <p className=' prop-detail'>{subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
                            </Grid>
                            <Grid item lg={3} className='first-row-item' >
                                <p className='prop-title'>Received From</p>
                                <p className=' prop-detail'>{dialogRowData.cfcName ? dialogRowData.cfcName : '-'}</p>
                            </Grid>
                        </Grid>
                        {/* Documents Section */}
                        <Grid item lg={12} className='application-details1' sx={{ marginTop: '20px' }}>
                            <p className='prop-title' style={{ fontWeight: 'bold', marginBottom: '10px' }}>Attached Documents</p>
                        </Grid>
                        <Grid item lg={12} sx={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                            {documnets?.applicantCNICFront && (
                                <Grid item>
                                    <p className='prop-title' style={{ marginBottom: '5px' }}>CNIC Front</p>
                                    <img
                                        src={documnets.applicantCNICFront}
                                        alt="CNIC Front"
                                        style={{
                                            width: '150px',
                                            height: '100px',
                                            objectFit: 'cover',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => OpenBase64ImageInPopup(documnets.applicantCNICFront)}
                                    />
                                </Grid>
                            )}
                            {documnets?.applicantCNICBack && (
                                <Grid item>
                                    <p className='prop-title' style={{ marginBottom: '5px' }}>CNIC Back</p>
                                    <img
                                        src={documnets.applicantCNICBack}
                                        alt="CNIC Back"
                                        style={{
                                            width: '150px',
                                            height: '100px',
                                            objectFit: 'cover',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => OpenBase64ImageInPopup(documnets.applicantCNICBack)}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-action'>
                    <p className='description'>Application Submitted by : {' '}
                        {String(dialogRowData.createdBy).length === 13 && /^\d+$/.test(dialogRowData.createdBy)
                            ? dialogRowData.name
                            : dialogRowData.createdBy} {' '}
                        on: {convertDatewithTime(dialogRowData.creationDate)}</p>
                </DialogActions>
            </Dialog >

            {/* Action Taken Popup - Shows Verified Documents */}
            <Dialog
                open={actionTakenPopup}
                onClose={() => { setActionTakenPopup(false) }}
                fullWidth={true}
                maxWidth={'md'}
                className='subpopup-dialog1'
            >
                <DialogTitle className='dialog-title'>
                    {
                        dialogRowData.applicationProgressId === 3 ? (
                            <p className='title'>Application Aproved</p>
                        ) : (dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus == 1) && (
                            <p className='title'>Application Reject</p>
                        )
                    }
                    <CloseIcon id="clearPopup" className='closeIcon' onClick={() => { setActionTakenPopup(false) }} />
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    {
                        dialogRowData.applicationProgressId === 3 ? (
                            <Grid container gap={2} className='container' sx={{ padding: '20px' }}>
                                <Grid item lg={12}>
                                    <p style={{ fontWeight: 'bold', marginBottom: '15px', fontSize: '16px' }}>Approved Part Payment</p>
                                </Grid>
                                <TextField
                                    type="number"
                                    value={approvedPayment}
                                    onChange={(e) => {
                                        setApprovedPayment(e.target.value);
                                        if (approvedPaymentError) setApprovedPaymentError('');
                                    }}
                                    fullWidth
                                    disabled
                                    placeholder="Enter amount"
                                    error={!!approvedPaymentError}
                                    InputProps={{
                                        startAdornment: (
                                            <span style={{ marginRight: '4px', fontWeight: 'bold' }}>
                                                Rs.
                                            </span>
                                        )
                                    }}
                                    sx={{
                                        backgroundColor: '#fff',
                                        '& .MuiInputBase-input': {
                                            fontWeight: 'bold',
                                            fontSize: '16px',
                                        },
                                    }}
                                />
                            </Grid>
                        )
                            :
                            (
                                <Grid container gap={2} className="container" sx={{ padding: '20px' }}>
                                    <Grid item lg={12}>
                                        <p style={{
                                            fontWeight: 'bold',
                                            marginBottom: '15px',
                                            fontSize: '16px',
                                            color: 'red'
                                        }}>
                                            The application is rejected by the sanctioned authority
                                        </p>
                                    </Grid>
                                </Grid>

                            )
                    }

                </DialogContent>
                <DialogActions className='dialog-action'>
                    <p className='description'>Application { dialogRowData.applicationProgressId === 3 ? 'Approved ' : (dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus == 1) && 'Reject '} by : {' '}
                        {String(dialogRowData.createdBy).length === 13 && /^\d+$/.test(dialogRowData.createdBy)
                            ? dialogRowData.name
                            : dialogRowData.createdBy} {' '}
                        on: {convertDatewithTime(dialogRowData.creationDate)}</p>
                </DialogActions>
            </Dialog>

            < Dialog
                open={approvedPopup}
                onClose={() => { setApprovedPopup(false); handleClose(); }}
                className='dialog'
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{ style: { width: '100%', borderRadius: 20 } }}
            >
                <DialogTitle  >
                    <Box className="backgroundAttached" >
                        <DoneIcon className="icon" />
                    </Box>
                    <Typography variant="h6" className="groupTitle"> Request Approved</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p className="applicationSubmit">  Due Date Extension request is Approved successfully.</p>
                        <p className="trackIdPara"><Button variant="outlined" onClick={() => { downloadBill(dialogRowData.refNo) }} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><DescriptionIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> Bill </Button></p>
                    </DialogContentText>
                </DialogContent>
            </Dialog >


            {/* Remarks Dialog */}
            <Dialog open={openCancelModal} className='objectionDialog' onClose={handleCloseRemarks} maxWidth="sm" fullWidth>
                <DialogTitle className="objection-dialog-title">
                    <Grid container className='objectionheadercontainer'>
                        <Grid item lg={11} className='applicationTitleGrid'>
                            <Typography className="applicationTitleText">Remarks</Typography>
                        </Grid>
                        <Grid item lg={1} className="closeIcon">
                            <CloseIcon id="clearPopup" onClick={handleCloseRemarks} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        placeholder="Enter Remarks"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={remarksFormik.handleChange}
                        onBlur={remarksFormik.handleBlur}
                        name="iv_remarks"
                        value={remarksFormik.values.iv_remarks}
                        multiline
                        rows={4}
                        InputLabelProps={{ shrink: false }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: 'rgba(173, 170, 170, 0.6)',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'rgba(173, 170, 170, 0.6)',
                                },
                            },
                        }}
                    />
                    {remarksFormik.touched.iv_remarks && remarksFormik.errors.iv_remarks && (
                        <p style={{ color: "#f73232", fontSize: "1rem" }}>
                            {remarksFormik.errors.iv_remarks}
                        </p>
                    )}
                    <Grid item lg={12} >
                        {
                            error &&
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        }
                    </Grid>
                    <DialogActions className="objection-dialog-action">
                        <Button onClick={remarksFormik.handleSubmit} type="submit" className='submit-button'>Confirm</Button>
                        <Button onClick={handleCloseRemarks} className='reject-button'>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Dialog
                open={apiPopup.open}
                onClose={() => {
                    setViewBackdrop(true);
                    dispatch(fetchPaginatedPartPaymentNormal({
                        page: currentPageNormal,
                        pageSize: pageSizeNormal,
                        dateFrom: dateFromNormal,
                        dateTo: dateToNormal,
                        applicationProgressId: applicationProgressIdNormal,
                        objectionStatus: objectionStatusNormal,
                        officeCode
                    }));
                    dispatch(fetchPaginatedPartPaymentOverdue({
                        page: currentPageOverdue,
                        pageSize: pageSizeOverdue,
                        dateFrom: dateFromOverdue,
                        dateTo: dateToOverdue,
                        applicationProgressId: applicationProgressIdOverdue,
                        objectionStatus: objectionStatusOverdue,
                        officeCode
                    }));

                    setApiPopup({ open: false, type: '', message: '' });
                    handleClose();
                }}
                className="dialog"
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        p: 2,
                        maxHeight: "90vh",
                        overflow: "hidden",
                    },
                }}
            >
                {apiPopup.message && (
                    <>
                        <DialogTitle sx={{ p: 0, mb: 1 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    mt: 1,
                                }}
                            >
                                {apiPopup.type === "success" ? (
                                    <CheckCircleIcon sx={{ color: "#24bf73", fontSize: "4rem" }} />
                                ) : (
                                    <ErrorIcon sx={{ color: "#d32f2f", fontSize: "4rem" }} />
                                )}
                            </Box>
                        </DialogTitle>

                        <DialogContent
                            sx={{
                                textAlign: "center",
                                px: 3,
                            }}
                        >
                            <DialogContentText
                                sx={{
                                    color: apiPopup.type === "success" ? "#2e7d32" : "#d32f2f",
                                    fontWeight: 600,
                                    fontSize: "1.1rem",
                                    mb: 2,
                                }}
                            >
                                {apiPopup.message}
                            </DialogContentText>

                            {apiPopup.type === "success" && (
                                <Box sx={{ textAlign: "center", mt: 2 }}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => downloadBill(dialogRowData.referenceNo)}
                                        sx={{
                                            border: "1px solid #006ad1",
                                            color: "#006ad1",
                                            backgroundColor: "white",
                                            textTransform: "none",
                                            px: 3,
                                            py: 1,
                                            "&:hover": {
                                                backgroundColor: "#f5f5f5",
                                                border: "1px solid #006ad1",
                                            },
                                        }}
                                    >
                                        <DescriptionIcon sx={{ color: "#006ad1", mr: 1 }} /> Download Bill
                                    </Button>
                                </Box>
                            )}
                        </DialogContent>
                    </>
                )}
            </Dialog >

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }
                }
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >

        </>
    )
})

export default AmendBill2636Table;